import type { ChapterUiState } from '@/components/ChapterSidebar';

/**
 * Sequential unlock: a chapter is `locked` iff it is not completed AND some earlier chapter
 * is not completed. The focused chapter renders `active`; other reachable chapters render
 * `done` if completed, else `active` (reachable but not yet completed).
 */
export function deriveChapterStates(
  orderedIds: string[],
  completedIds: string[],
  focusedId: string,
): Record<string, ChapterUiState> {
  const completed = new Set(completedIds);
  const out: Record<string, ChapterUiState> = {};
  let allPriorComplete = true;
  for (const id of orderedIds) {
    const isCompleted = completed.has(id);
    const reachable = isCompleted || allPriorComplete;
    if (id === focusedId && reachable) {
      out[id] = 'active';
    } else if (!reachable) {
      out[id] = 'locked';
    } else {
      out[id] = isCompleted ? 'done' : 'active';
    }
    allPriorComplete = allPriorComplete && isCompleted;
  }
  return out;
}

/** Quiz unlocks only when every chapter is completed. */
export function isQuizUnlocked(orderedIds: string[], completedIds: string[]): boolean {
  const completed = new Set(completedIds);
  return orderedIds.length > 0 && orderedIds.every((id) => completed.has(id));
}
